var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"camions-1"},[_c('div',{staticClass:"x-lorem-ipsum-lorem-ipsum isidorasansalt-bold-gunsmoke-20px"},[_c('span',{staticClass:"isidorasansalt-bold-white-20px"},[_vm._v(_vm._s(_vm.spanText1))]),_c('br'),_c('span',{staticClass:"span-52 montserrat-normal-white-14px"},[_vm._v(_vm._s(_vm.spanText2))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }